import { render, staticRenderFns } from "./ModalCarCategoryNew.vue?vue&type=template&id=626a7294&"
import script from "./ModalCarCategoryNew.vue?vue&type=script&lang=js&"
export * from "./ModalCarCategoryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports